import { EffectReducer } from 'use-effect-reducer';
import { PostEditorGroupDataActions } from './PostEditorGroupDataActions';
import { TabIndexEffectsType } from './PostEditorGroupDataEffects';
import { CaptionWriterViewType, PostEditorGroupDataType } from './PostEditorGroupDataProvider';
import { ImmutabilityContext } from './effects/customImmutabilityContext';
import { GENERATING_CAPTIONS_PLACEHOLDER } from './initial';

export const PostEditorGroupDataReducer: EffectReducer<
  PostEditorGroupDataType,
  PostEditorGroupDataActions,
  TabIndexEffectsType
> = (state, action, effect) => {
  const { update: updateImmutable } = ImmutabilityContext;
  switch (action.type) {
    case 'initateCaptions':
      effect({ type: 'initiateCaptionsEffect', payload: action.payload });
      return updateImmutable(state, {
        aiCaptionWriter: {
          loading: { $set: true },
          cacheKey: { $set: '' },
          viewType: { $set: CaptionWriterViewType.results },
          captionResults: { $set: GENERATING_CAPTIONS_PLACEHOLDER }
        }
      });
    case 'getCaptions':
      effect({ type: 'getCaptionsEffect', payload: action.payload });
      return updateImmutable(state, {
        aiCaptionWriter: {
          loading: { $set: true },
          viewType: { $set: CaptionWriterViewType.results }
        }
      });
    case 'setAiCacheKey':
      return updateImmutable(state, {
        aiCaptionWriter: {
          cacheKey: { $set: action.payload }
        }
      });
    case 'setAiLoading':
      return updateImmutable(state, {
        aiCaptionWriter: {
          loading: { $set: action.payload }
        }
      });
    case 'setAiLimitReached':
      return updateImmutable(state, {
        aiCaptionWriter: {
          limitReached: { $set: action.payload }
        }
      });
    case 'setAiResults':
      return updateImmutable(state, {
        aiCaptionWriter: {
          captionResults: { $set: action.payload }
        }
      });
    case 'setError':
      effect({ type: 'showErrorToastEffect', payload: action.payload });
      return updateImmutable(state, {
        aiCaptionWriter: {
          loading: { $set: false }
        }
      });
    case 'setAiGqlFunctions': {
      const { getCaptionsQuery, initiateCaptionsMutation, stopCaptionsMutation } = action.payload;
      return updateImmutable(state, {
        aiCaptionWriter: {
          getCaptionsQuery: { $set: getCaptionsQuery },
          initiateCaptionsMutation: { $set: initiateCaptionsMutation },
          stopCaptionsMutation: { $set: stopCaptionsMutation }
        }
      });
    }
    case 'setAiPromptsAndViewType':
      const { propmptBase, prompt, viewType } = action.payload;
      return updateImmutable(state, {
        aiCaptionWriter: {
          promptLabel: { $set: prompt ? 'Edit your prompt' : 'Or write your own prompt' },
          prompt: { $set: prompt },
          propmptBase: { $set: propmptBase },
          viewType: { $set: viewType }
        }
      });
    case 'setAiViewType':
      return updateImmutable(state, {
        aiCaptionWriter: {
          viewType: { $set: action.payload }
        }
      });
    case 'setIndex':
      return updateImmutable(state, {
        tabs: {
          [`${action.payload.side}TabsIndex`]: { $set: action.payload.value }
        }
      });
    case 'setPostGroupIndex':
      return updateImmutable(state, {
        postGroupIndex: { $set: action.payload }
      });
    case 'setType':
      return updateImmutable<PostEditorGroupDataType>(state, {
        tabs: {
          tabsType: {
            $apply: current => action.payload ?? current
          }
        }
      });
    case 'stopAiCaptions':
      effect({ type: 'stopCaptionsEffect' });
      return state;
    case 'setForceStopped':
      return updateImmutable<PostEditorGroupDataType>(state, {
        aiCaptionWriter: {
          forceStopped: {
            $set: action.payload
          }
        }
      });
    default:
      return state;
  }
};
